import { render, staticRenderFns } from "./cardLoanTabbar.vue?vue&type=template&id=54d40084&scoped=true&"
import script from "./cardLoanTabbar.vue?vue&type=script&lang=js&"
export * from "./cardLoanTabbar.vue?vue&type=script&lang=js&"
import style0 from "./cardLoanTabbar.vue?vue&type=style&index=0&id=54d40084&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d40084",
  null
  
)

export default component.exports